import { Component, OnInit } from '@angular/core';
import { isEmpty } from 'lodash';
import {
  BaseComponent,
  LoadingState,
  SearchResult,
  getUrlParams,
} from 'src/app/shared';
import {
  DetailSearchConfiguration,
  SearchRequest,
  SearchService,
  Session,
  TranslationService,
  UserRoleService,
} from '../..';
import { srSpeak } from '../../../shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-search-page',
    template: `
    <app-section>
      <app-claim-breadcrumb></app-claim-breadcrumb>
      <app-panel
        [title]="
          this.showEmployeeSearch || showControllerSearch
            ? 'Search'
            : 'Claim search'
        "
        [headerLevel]="1"
        [canExpand]="false"
        class="tw-w-full tw-min-h-[1000px]"
      >
        <div
          *ngIf="
            selectedClientID !== undefined &&
            selectedClientID < 0 &&
            IsMultiClient
          "
        >
          <app-toast type="Info" class="toast-header wrap-content"
            >&nbsp;&nbsp;
            <span>
              {{ 
                'Welcome to the Auditor dashboard. To begin, please select a client from the dropdown in the auditor toolbar. You will then be able to search for a person to mimic.'
                | translation: translationRequest
              }}
            </span>
          </app-toast>
        </div>
        <div
          role="search"
          *ngIf="
            !IsMultiClient ||
            (selectedClientID !== undefined && selectedClientID > 0)
          "
        >
          <app-tab-group [hideSingleTab]="true" [tabGroupId]="'searchTabGroup'">
            <app-tab
              label="Employees"
              id="employeesTab"
              featureName="Employees"
              *ngIf="showEmployeeSearch"
              [template]="employee"
            >
              <ng-template #employee>
                <div class="tw-pt-4"></div>
                <app-detail-search-form
                  #employeeSearchForm
                  [config]="employeeConfig"
                  (search)="searchEmployees($event)"
                  (clear)="employeeLoading = 'Init'"
                  [loading]="employeeLoading"
                  loadingImageSrc="/assets/images/loader/search-results-ghost.svg"
                  [translationRequest]="translationRequest"
                >
                  <ng-template #results>
                    <app-search-count-row
                      [count]="employeeSearchResults.length"
                      resultSingle="result"
                      resultPlural="results"
                    ></app-search-count-row>
                    <app-search-employees-list
                      [searchResults]="employeeSearchResults"
                      class="tw-w-full"
                      (export)="employeeSearchForm.appendExport($event)"
                      [translationRequest]="translationRequest"
                    />
                  </ng-template>
                </app-detail-search-form>
              </ng-template>
            </app-tab>
            <app-tab
              label="Claimants"
              id="claimsTab"
              *ngIf="showClaimSearch"
              [template]="claimant"
            >
              <ng-template #claimant>
                <div class="tw-pt-4"></div>
                <app-detail-search-form
                  #claimSearchForm
                  [config]="config"
                  (search)="searchClaims($event)"
                  (clear)="loading = 'Init'"
                  [loading]="loading"
                  loadingImageSrc="/assets/images/loader/search-results-ghost.svg"
                  [translationRequest]="translationRequest"
                >
                  <ng-template #results>
                    <app-search-count-row
                      [count]="searchResults.length"
                    ></app-search-count-row>
                    <app-search-results-list
                      [searchResults]="searchResults"
                      class="tw-w-full"
                      (export)="claimSearchForm.appendExport($event)"
                      [translationRequest]="translationRequest"
                    />
                  </ng-template>
                </app-detail-search-form>
              </ng-template>
            </app-tab>
            <!-- claiment Controller --->
            <app-tab
              label="Claim Administrators"
              id="claimsTabCnt"
              *ngIf="showControllerSearch"
              [template]="claimantCtr"
            >
              <ng-template #claimantCtr>
                <div class="tw-pt-4"></div>
                <app-detail-search-form
                  #claimControllerSearchForm
                  [config]="controllerConfig"
                  (search)="searchClaimController($event)"
                  (clear)="controllerLoading = 'Init'"
                  [loading]="controllerLoading"
                  loadingImageSrc="/assets/images/loader/search-results-ghost.svg"
                  [translationRequest]="translationRequest"
                >
                  <ng-template #results>
                    <app-search-count-row
                      [count]="controllerSearchResults.length"
                    ></app-search-count-row>
                    <app-search-controller-list
                      [searchResults]="controllerSearchResults"
                      [isController]="true"
                      class="tw-w-full"
                      (export)="claimControllerSearchForm.appendExport($event)"
                    />
                  </ng-template>
                </app-detail-search-form>
              </ng-template>
            </app-tab>
          </app-tab-group>
        </div>
      </app-panel>
    </app-section>
  `,
    styles: [
        `
      .toast-header {
        line-height: 24px;
        font-weight: normal;
        font-size: medium;
      }
      .wrap-content {
        white-space: normal !important;
      }
    `,
    ],
    standalone: false
})
export class SearchPageComponent extends BaseComponent implements OnInit {
  config = new DetailSearchConfiguration();
  controllerConfig = new DetailSearchConfiguration();

  employeeConfig = new DetailSearchConfiguration();

  searchResults: SearchResult[];

  employeeSearchResults: SearchResult[];

  controllerSearchResults: SearchResult[];

  loading: LoadingState = 'Init';

  employeeLoading: LoadingState = 'Init';
  controllerLoading: LoadingState = 'Init';
  showEmployeeSearch: boolean;

  showClaimSearch: boolean;

  showControllerSearch: boolean = true;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Searchpage',
    subGroup: 'Searchpage',
  });

  get selectedClientID() {
    if (this.session.SelectedContNum != '-1') {
      return Number(this.session.SelectedContNum);
    } else {
      return -1;
    }
  }

  get IsMultiClient() {
    if (
      this.session.user.clients != undefined &&
      this.session.user.clients.length > 1
    ) {
      return true;
    } else {
      return false;
    }
  }

  constructor(
    public searchService: SearchService,
    public userRole: UserRoleService,
    public session: Session,
    private translationService: TranslationService,
  ) {
    super();
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  async ngOnInit() {
    
    if (this.userRole.auditor) {
      console.log('auditor');
      this.showClaimSearch =
        this.session.user.hasLiabilityLob ||
        (this.session.user.registrationMethod === 'CLAIM' &&
          this.session.user.lineOfBusiness.some(
            (lobObj) => lobObj.lob === 'WC' || lobObj.lob === 'DS'
          ));

      this.showEmployeeSearch =
        this.session.user.registrationMethod === 'HR' ||
        this.session.user.registrationMethod === 'NONE';
      this.showControllerSearch =
        this.userRole.auditor && this.session.user.isControllerAccessEnabled;
    } else {
      this.showClaimSearch = true;
      this.showEmployeeSearch = false;
      this.showControllerSearch = false;
    }

    this.initClaimConfig(
      this.userRole.auditor && this.session.user.hasLiabilityLob
    );
    this.initEmployeeConfig();

    this.initControllerConfig(
      this.userRole.auditor && this.session.user.hasLiabilityLob
    );
    this.loadTranslations();
  }

  async searchClaimController(searchRequest: SearchRequest) {
    this.controllerLoading = 'Loading';
    const parameters = searchRequest.getParameters();
    if (this.userRole.auditor) {
      parameters.IsLiabilityClaimSearch = this.session.user.hasLiabilityLob;
      parameters.IsAuditorConrollerSearch = true;
    }
    const searchInformation = await this.searchService.getSearchResults(
      parameters
    );

    this.controllerSearchResults = searchInformation.searchResults;
    this.controllerLoading =
      this.controllerSearchResults.length > 0 ? 'Loaded' : 'Empty';
    if (
      this.controllerSearchResults &&
      this.controllerSearchResults.length === 0
    ) {
      srSpeak('There are no results that match the search', 'polite');
    }
  }

  async searchClaims(searchRequest: SearchRequest) {
    this.loading = 'Loading';
    const parameters = searchRequest.getParameters();
    if (this.userRole.auditor) {
      parameters.IsLiabilityClaimSearch = this.session.user.hasLiabilityLob;
    }
    const searchInformation = await this.searchService.getSearchResults(
      parameters
    );
    this.config.initialSearch = false;
    this.searchResults = searchInformation.searchResults;
    this.loading = this.searchResults.length > 0 ? 'Loaded' : 'Empty';
    if (this.searchResults && this.searchResults.length === 0) {
      srSpeak('There are no results that match the search', 'polite');
    }
  }

  override ngOnDestroy(): void {
    this.config.initialSearch = true;
  }

  async searchEmployees(searchRequest: SearchRequest) {
    this.employeeLoading = 'Loading';
    const searchInformation = await this.searchService.getSearchResults(
      searchRequest.getParameters()
    );

    this.employeeSearchResults = searchInformation.searchResults;
    this.employeeLoading =
      this.employeeSearchResults.length > 0 ? 'Loaded' : 'Empty';
    if (this.employeeSearchResults && this.employeeSearchResults.length === 0) {
      srSpeak('There are no results that match the search', 'polite');
    }
  }

  private initClaimConfig(isAuditorLiabilitySearch: boolean) {
    this.config.key = 'search-page-claims';
    this.config.managerLookupSupervisor = true;
    this.config.managerLookupOmni = true;
    this.config.emptyFormAllowed = false;
    this.config.initialValue = {
      includeIndirectReports: true,
    };

    this.config.employeeId.visible = !this.userRole.controller;
    this.config.includeIndirect.visible = !this.userRole.controller;
    this.config.supervisor.visible = !this.userRole.controller;
    this.config.maxBackDays = null;

    // checking query string parameters. Quick search
    // passes search inputs on query string
    const params = getUrlParams();
    if (!isEmpty(params)) {
      this.config.initialValue = Object.assign(
        params,
        this.config.initialValue
      );
      this.config.initialSearch = true;
      this.config.clearParameters = true;
    }

    if (isAuditorLiabilitySearch) {
      this.config.employeeId.visible = false;
      this.config.managerLookupOmni = false;
      this.config.managerLookupSupervisor = false;
      this.config.includeIndirect.visible = false;
      this.config.limitLobsToLiability = true;
    }

    this.config.payType.visible =
      this.session.user.employeeType &&
      (this.session.user.roles.supervisor ||
        this.session.user.roles.omni ||
        this.session.user.roles.overseer);
  }

  private initEmployeeConfig() {
    this.employeeConfig.key = 'search-page-employees';
    this.employeeConfig.managerLookupSupervisor = true;
    this.employeeConfig.managerLookupOmni = true;
    this.employeeConfig.emptyFormAllowed = false;
    this.employeeConfig.initialValue = {
      includeIndirectReports: true,
    };

    this.employeeConfig.setVisibility(false);
    this.employeeConfig.firstName.visible = true;
    this.employeeConfig.lastName.visible = true;
    this.employeeConfig.employeeId.visible = true;
    this.employeeConfig.initialSearchMsg =
      'Employee search results will appear here.';
  }

  private initControllerConfig(isAuditorLiabilitySearch: boolean) {
    this.controllerConfig.key = 'search-page-controller';
    this.controllerConfig.managerLookupSupervisor = true;
    this.controllerConfig.managerLookupOmni = true;
    this.controllerConfig.emptyFormAllowed = false;
    this.controllerConfig.initialValue = {
      includeIndirectReports: true,
    };

    if (isAuditorLiabilitySearch) {
      this.controllerConfig.employeeId.visible = false;
      this.controllerConfig.managerLookupOmni = false;
      this.controllerConfig.managerLookupSupervisor = false;
      this.controllerConfig.includeIndirect.visible = false;
      this.controllerConfig.limitLobsToLiability = true;
    }

    this.controllerConfig.setVisibility(false);
    this.controllerConfig.firstName.visible = true;
    this.controllerConfig.lastName.visible = true;
    this.controllerConfig.email.visible = true;
    this.controllerConfig.employeeId.visible = false;

    this.controllerConfig.initialSearchMsg =
      'Controller search results will appear here.';
  }
}
